/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Editor_BlockquoteInputs */

const en_common_editor_blockquote = /** @type {(inputs: Common_Editor_BlockquoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blockquote`)
};

const zh_common_editor_blockquote = /** @type {(inputs: Common_Editor_BlockquoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`引用`)
};

/**
* | output |
* | --- |
* | "Blockquote" |
*
* @param {Common_Editor_BlockquoteInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_editor_blockquote = /** @type {((inputs?: Common_Editor_BlockquoteInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Editor_BlockquoteInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_editor_blockquote(inputs)
	return zh_common_editor_blockquote(inputs)
});
export { common_editor_blockquote as "common.editor.blockquote" }